<div class="missing-inspections-page">
	<div class="header-row">
		<div fxFlexLayout="row" fxLayoutAlign="space-between center">
			<div class="heading-1">
				<h1 class="page-title">
					{{ "missing inspections" | i18next: { format: "title" } }}
					<span class="missing-inspections-record-count">({{ missingInspectionsListCount }})</span>
				</h1>
				<app-action-button id="new_report_btn" *ngIf="showNewReportBtn"
					[title]="isOldMIR ? '(NEW) Customize Missing Inspections' : '(OLD) Missing Inspections'"
					(click)="navigateToMIR()">
				</app-action-button>

			</div>

			<app-export [disabled]="!selectionModel || !selectionModel.selected?.length"
				[disableAllExport]="missingInspectionsListCount === 0" [showAllExport]="true"
				(csvExportReport)="exportCSV()" (pdfExportReport)="exportPDF()"
				(allCSVExportReport)="exportAllCSV()"></app-export>
		</div>
	</div>

	<div class="report-information">
		<button #infoButton mat-icon-button class="info-icon" (click)="openInfoDialog()"
			[attr.aria-label]="'how we identify missing inspections' | i18next">
			<mat-icon class="material-icons-outlined" aria-hidden="true">info</mat-icon>
		</button>
		<span>{{ "how we identify missing inspections" | i18next: { format: "capitalize" } }}</span>
	</div>

	<div class="tab-control">
		<app-tab-control [tabs]="tabs" (selected)="selectTab($event)"></app-tab-control>
	</div>

	<app-filter-card [enabledFilters]="enabledFilters" [context]="'missing-inspections'"
		(filterQueryObject)="handleFilterValues($event)"></app-filter-card>

	<div class="missing-inspections-table-wrapper" *ngIf="!isInitiallyLoading">

		<div class="missing-inspections-panels" tabindex="-1">
			<app-table [sortActive]="sortActive" [sortDirection]="sortDirection" (sortChange)="onMatSortChange($event)"
				[dataSource]="getDataSource()" (selectionModelChange)="selectionModel = $event"
				(sortObjChanged)="receiveSortObj($event)" [view]="view">
				<!-- Inspector View Columns  -->
				<!-- Start Time column Inspector  -->
				<app-column name="date" id="start-time" sortable="true" type="single-value" data="startTime"
					view="inspectors"></app-column>

				<!-- Inspector Name Column Inspector -->
				<app-column name="inspector" id="inspector-name" sortable="true" type="single-value" data="inspector"
					view="inspectors"></app-column>

				<!-- Inspection Type Column Inspector -->
				<app-column name="insp type" id="inspection-type" sortable="true" type="multiple-values"
					data="inspection.type" view="inspectors"></app-column>

				<!-- Home Location Column Inspector -->
				<app-column name="home location" id="home-location" type="single-value" data="division"
					view="inspectors"></app-column>

				<!-- Asset View Columns  -->
				<!-- Start Time Column Assets -->
				<app-column name="date" id="start-time" sortable="true" type="single-value" data="startTime"
					view="assets"></app-column>

				<!-- Asset Number Column Assets -->
				<app-column name="asset number" id="asset-number" sortable="true" type="single-value" data="asset.name"
					view="assets" routerLinkData="{ &quot;path&quot;: &quot;/company/{{
						companyId
					}}/asset-details&quot;, &quot;idExp&quot;: &quot;asset.id&quot; }"></app-column>

				<!-- Asset Type Column Assets -->
				<app-column name="asset type" id="asset-type" sortable="true" type="single-value" data="asset.type"
					view="assets"></app-column>

				<!-- Inspection Type Column Assets -->
				<app-column name="insp type" id="inspection-type" sortable="true" type="multiple-values"
					data="inspection.type" view="assets"></app-column>

				<!-- Home Location Column Assets -->
				<app-column name="home location" id="home-location" type="single-value" data="division"
					view="assets"></app-column>

				<!-- GPS Asset View Columns  -->
				<!-- Start Time Column Gps Assets -->
				<app-column name="start date / time" id="start-time" sortable="true" type="multiple-values"
					data="startTime" view="gps"></app-column>

				<!-- End Time Column Gps Assets -->
				<app-column *ngIf="!isOldMIR" name="end date / time" id="end-time" sortable="true"
					type="multiple-values" data="endTime" view="gps"></app-column>

				<!-- Asset Id Column Gps Assets -->
				<app-column name="asset id" id="asset-id" sortable="true" type="single-value" data="asset.name"
					view="gps" routerLinkData="{ &quot;path&quot;: &quot;/company/{{
						companyId
					}}/asset-details&quot;, &quot;idExp&quot;: &quot;asset.id&quot; }"></app-column>

				<!-- Asset Type Column Gps Assets -->
				<app-column name="asset type" id="asset-type" sortable="true" type="single-value" data="zoneLayout"
					view="gps"></app-column>

				<!-- Inspection Type Column Gps Assets -->
				<app-column name="insp type" id="inspection-type" sortable="true" type="multiple-values"
					data="inspection.type" view="gps"></app-column>

				<!-- Distance Traveled Column Gps Assets -->
				<app-column *ngIf="!isOldMIR" name="distance traveled" id="distance-traveled" type="single-value"
					sortable="true" data="distance" view="gps" blankPage="true"
					routerLinkData="{ &quot;path&quot;: &quot;{{
						zonarMapUrl
					}}&quot;, &quot;idExp&quot;: &quot;asset.id&quot;, &quot;additional&quot;: &quot;/history?recentPathStartTime=&quot;, &quot;additional2&quot;:&quot;@isoTime&quot;,&quot;transformFn&quot;:&quot;datetimeTransformFn&quot; }"></app-column>

				<!-- Trip Duration Column Gps Assets -->
				<app-column *ngIf="!isOldMIR" name="trip duration" id="trip-duration" sortable="true"
					type="single-value" data="duration" view="gps"></app-column>

				<!-- Home Location Column Gps Assets -->
				<app-column name="home location" id="home-location" type="single-value" data="division"
					view="gps"></app-column>

				<!-- See in Live Maps button Column Gps Assets-->
				<!--
				The assignment for routerLinkData is confusing.  A Make it Great ticket has been created to improve this: EVIR2-5014

				For now, this comment should help.

				What is being passed to TableComponent is a json object of the form:
				{"path": "{{zonarMapUrl}}"},
				{"idExp": "{{ass}}"},
				{"additional": "/history?recentStartTime="},
				{"additional2": "@isoTime"},
				{"transformFn": "datetimeTransformFn"}

			The keys "additional", "additional2", and "transformFn" are used by
			the table.component to construct the url for the routerLink.

			"additional" - a query string that is appended to "path"
			"additional2" - specifies a value for the query string
			        If there is an "@" prepended to this value, then it is
							used as a key to lookup from the data for the row.
			"transformFn" - specifies a function for transforming the "additional2" value
			        into a suitable query string value.  "transformFn" is a key for
							a map of functions in ./components/table/column-transforms/index.ts

			-->
				<app-column *ngIf="displayLiveMaps" name="" id="live-map" type="button" data="see in live maps"
					view="gps"
					routerLinkData="{ &quot;path&quot;: &quot;{{
						zonarMapUrl
					}}&quot;, &quot;idExp&quot;: &quot;asset.id&quot;, &quot;additional&quot;: &quot;/history?recentPathStartTime=&quot;, &quot;additional2&quot;:&quot;@isoTime&quot;,&quot;transformFn&quot;:&quot;datetimeTransformFn&quot; }"></app-column>
			</app-table>
		</div>

		<mat-card *ngIf="isInitiallyLoading" class="initial-loading-card" fxLayout="column"
			fxLayoutAlign="center center"></mat-card>

		<app-no-results-card *ngIf="missingInspectionsListCount === 0 && !isInitiallyLoading"
			[message]="modifySearchString" tabindex="-1"></app-no-results-card>

		<app-paginator #appPaginator *ngIf="missingInspectionsListCount !== 0 && !isInitiallyLoading"
			[length]="missingInspectionsListCount" [pageSizeOptions]="pageSizeOptions"
			(pageQueryChange)="onQueryChange($event)"></app-paginator>
	</div>
</div>
